import AccessRightsNoPermissionView from '../access-rights/AccessRightsNoPermissionView';

function NoAccess() {
  return <AccessRightsNoPermissionView />;
}

export default NoAccess;
